import React, { useEffect, useState } from 'react'
import { useLocation, useHistory } from 'react-router-dom'
import AuthLayout from '../../components/auth/AuthLayout'
import TokenForm from '../../components/auth/TokenForm'
import { verify_reset_token, request_new_password } from '../../server/server'
import { usePageTitle } from '../../utils/util'

const VerifyTokenScreen = () => {
    usePageTitle(`Upstrive Education - Verify Token`)
    const history = useHistory()
    const location = useLocation()
    const [token, setToken] = useState('')
    const [email, setEmail] = useState('')
    const [isLoading, setIsLoading] = useState(false)
    const [errorMessage, setErrorMessage] = useState('')

    useEffect(() => {
        // Get email from URL params
        const searchParams = new URLSearchParams(location.search)
        const emailParam = searchParams.get('email')
        if (emailParam) {
            setEmail(decodeURIComponent(emailParam))
        } else {
            // If no email, redirect to forgot password
            history.push('/auth/forgot-password')
        }
    }, [location, history])

    const onTokenSubmit = async (token) => {
        setIsLoading(true)
        setErrorMessage('')

        try {
            const response = await verify_reset_token({ email, token })
            if (response.status === 200) {
                // Navigate to new password screen with validated token
                history.push(`/auth/new-password?token=${response.data}&email=${encodeURIComponent(email)}`)
            } else {
                setErrorMessage(response.data)
            }
        } catch (e) {
            console.log(e)
            setErrorMessage('Error')
        }

        setIsLoading(false)
    }

    const onRepeatRequest = async () => {
        try {
            const response = await request_new_password({ email })
            return response
        } catch (e) {
            console.log(e)
            return { data: 'Error', success: false }
        }
    }

    const handleBack = () => {
        history.push('/auth/forgot-password')
    }

    return (
        <AuthLayout>
            <TokenForm
                token={token}
                setToken={setToken}
                onSubmit={onTokenSubmit}
                onBack={handleBack}
                onRepeatRequest={onRepeatRequest}
                isLoading={isLoading}
                errorMessage={errorMessage}
            />
        </AuthLayout>
    )
}

export default VerifyTokenScreen
